var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlueTicks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7802 0.581436C12.9517 0.435981 13.209 0.435981 13.3806 0.508709L13.7236 0.654163C13.8952 0.799618 13.8952 1.0178 13.8094 1.16325L8.06282 7.27234C7.80551 7.49053 7.37667 7.56325 7.20513 7.34507L6.26166 6.54507C6.09012 6.39962 6.09012 6.18144 6.26166 6.03598L6.51897 5.8178C6.69051 5.67234 6.94782 5.67234 7.11936 5.8178C7.11936 5.8178 7.2909 5.96325 7.54821 6.10871L12.7802 0.581436ZM9.94977 0.654163C10.1213 0.799618 10.1213 1.0178 10.0355 1.16325L4.28895 7.27234C4.03164 7.49053 3.68856 7.56325 3.43125 7.34507L0.858147 5.16325C0.686607 5.0178 0.686607 4.79962 0.858147 4.65416L1.11546 4.43598C1.287 4.29053 1.54431 4.29053 1.71585 4.43598L3.77433 6.10871L9.09207 0.581436C9.26361 0.435981 9.52092 0.435981 9.69246 0.508709L9.94977 0.654163Z",
    fill: "#42A5F5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueTicks);
export default __webpack_public_path__ + "static/media/blue-ticks.9cdb001bf941525e4b3a7dd1f5407274.svg";
export { ForwardRef as ReactComponent };